export default function getIdFormat(label) {
  return label.replace(/ /g, '_').toLowerCase()
}
